import ChatUtils from '@/utils/ChatUtils';
import { deleteCookie } from '@/access'
import { message as Msg } from 'antd';
// import Message from "@/mode/Message";
// import Receipt from "@/mode/Receipt";

export interface Message {
  //消息id,雪花id,有序增长
  id?: string;
  //聊天室id
  chatId: string;
  //消息发送人
  fromId: string;
  //发送人头像
  avatar: string;
  //发送人名称
  name: string;
  //是否是本人
  mine: boolean;
  //消息内容
  content: string;
  //消息时间
  timestamp: number;
  //消息类型：私聊|群聊
  type: string;
  // 聊天类型：咨询1|解答2
  chatType: number;
}

/**
 * 接受到的消息回执
 */
export interface Receipt {
  chatId: string;
  userId: string;
  timestamp: number;
  type: string;
  chatType: number;
}

const ready = { code: ChatUtils.MessageInfoType.MSG_READY };
const ping = { code: ChatUtils.MessageInfoType.MSG_PING };
// const LoginPageUrl = SSOServer ? `${SSOServer}/login` : '';

class WsRequest {
  status: string | null;
  lockReconnect: boolean;
  url: string | undefined;
  isConnected: boolean;
  //是否主动关闭
  closeByUser: boolean;
  timeout: number;
  timeoutTask: NodeJS.Timeout | null;
  reconnectTimeoutTask: NodeJS.Timeout | null;
  socket: WebSocket | null;
  msgHandler: ((message: any) => any) | null;

  constructor() {
    this.status = null; // websocket是否关闭
    this.lockReconnect = false; //避免重复连接
    this.url = '';
    this.isConnected = false;
    //是否主动关闭
    this.closeByUser = false;
    //心跳检测
    this.timeout = 30000; //多少秒执行检测
    //检测服务器端是否还活着
    this.timeoutTask = null;
    //重连之后多久再次重连
    this.reconnectTimeoutTask = null;
    this.socket = null;
    this.msgHandler = null;
  }

  public init(url?: string, msgHandler?: (msg: any) => any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // console.log('初始化websocket');***************************************************
      // 清除过长cookie
      deleteCookie('sysUiInfo')
      this.url = url;
      if (msgHandler && typeof msgHandler === 'function') {
        this.msgHandler = msgHandler;
      }
      if (this.url) {
        this.socket = new WebSocket(this.url);
        this.socket.onopen = () => {
          //告知服务器准备就绪
          this.send(ready);
          // 清除重连定时器
          if (this.reconnectTimeoutTask) {
            clearTimeout(this.reconnectTimeoutTask);
          }
          // 开启检测
          this.reset();
          resolve(true);
        };

        // 如果希望websocket连接一直保持，在close或者error上绑定重新连接方法。
        this.socket.onclose = (event: Event) => {
          // console.log('websocket关闭:', event); ********************************************
          if (!this.closeByUser) {
            this.isConnected = false;
            this.reconnect();
          }
          reject(false);
        };

        this.socket.onerror = (event: Event): any => {
          console.log('websocket错误:', event);
          this.isConnected = false;
          this.reconnect();
          reject(false);
        };

        this.socket.onmessage = (event: MessageEvent) => {
          const data = event.data;
          const sendInfo = JSON.parse(data);
          // 真正的消息类型
          // if (
          //   sendInfo.code === ChatUtils.MessageInfoType.MSG_MESSAGE ||
          //   sendInfo.code === ChatUtils.MessageInfoType.MSG_USER_READ
          // ) {
          if (sendInfo.code === ChatUtils.ErrorType.TOKEN_ERROR) {
            this.close();
            Msg.error(sendInfo.msg);
            setTimeout(() => {
              window.location.href = '/user/login';
              // window.location.href = LoginPageUrl;
            }, 2000);
          }
          this.onmessage(sendInfo);
          // }
          //接受任何消息都说明当前连接是正常的
          this.reset();
        };
      } else {
        console.error('请提供链接地址...');
        reject(false);
      }
    });
  }

  /**
   * 发送状态
   * @param value
   */
  send(value: any): void {
    if (this.socket?.readyState === 1) {
      this.socket.send(JSON.stringify(value));
    } else {
      this.reset();
      this.reconnect();
    }
  }

  /**
   * 收到消息，这里会被重写覆盖
   * @param message 消息
   */
  onmessage = (message: Message): void => {
    console.log('message', message);
    if (this.msgHandler && typeof this.msgHandler === 'function') {
      this.msgHandler(message);
    }
  };

  /**
   * 发送真正的聊天消息
   * @param message 消息
   */
  sendMessage(message: Message): void {
    const sendInfo = {
      code: ChatUtils.MessageInfoType.MSG_MESSAGE,
      message: message,
    };
    this.send(sendInfo);
  }

  /**
   * 发送已读取消息
   * @param receipt 消息读取回执
   */
  sendRead(receipt: Receipt): void {
    const sendInfo = {
      code: ChatUtils.MessageInfoType.MSG_READ,
      message: receipt,
    };
    this.send(sendInfo);
  }

  /**
   *  reset和start方法主要用来控制心跳的定时。
   */
  reset(): void {
    // 清除定时器重新发送一个心跳信息
    if (this.timeoutTask) {
      clearTimeout(this.timeoutTask);
    }
    this.timeoutTask = setTimeout(() => {
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      this.send(ping);
    }, this.timeout);
  }

  // 重连
  reconnect(): void {
    // console.log('lockReconnect', this.lockReconnect); ***************************************************
    // 防止多个方法调用，多处重连
    if (this.lockReconnect) {
      return;
    }
    this.lockReconnect = true;

    //没连接上会一直重连，设置延迟避免请求过多
    this.reconnectTimeoutTask = setTimeout(async () => {
      // 重新连接
      await this.init(this.url);
      this.lockReconnect = false;
    }, 5000);
  }

  // 手动关闭
  close(): void {
    //主动关闭
    if (this.timeoutTask) {
      clearTimeout(this.timeoutTask);
    }
    if (this.reconnectTimeoutTask) {
      clearTimeout(this.reconnectTimeoutTask);
    }
    this.closeByUser = true;
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default WsRequest;
